import "@Styles/mandate.css";
import React, { Component } from "react";
import { connect } from "react-redux";
import ModalBox from "../../../helper/modalBox";
import { payme_nbfc_heading, payme_nbfc_list } from "../../../helper/modalConstant";
import { withRouter } from "../../../hooks/withRouter";
import { recordEvent } from "../../../utils/appFlyer";
import Heading from "../Common/MainHeading";
import { HEADING_ASSIGNINGNBFC } from "../Common/constant";

class AssigningNbfc extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modalState:false,
      minutes: 0,
      seconds: 0,
      show: false,
    };
}
  setModelState=(props)=>{
    this.setState({modalState:props})
  }
  handleShow = () =>{
    this.setState({show: true})
    
  }
  handleClose = () =>{
    this.setState({show: false})
  }
  componentDidMount = () => {
    this.setState({ minutes: 5, seconds: 0 });
    this.myInterval = setInterval(() => {
      this.setState({ resendOtp: false }, () => {});
      const { seconds, minutes } = this.state;
      if (seconds > 0) {
        this.setState(({ seconds }) => ({
          seconds: seconds - 1,
        }));
      }
      if (seconds === 0) {
        if (minutes === 0) {
          clearInterval(this.myInterval);
          this.setState({ resendOtp: true });
        } else {
          this.setState(({ minutes }) => ({
            minutes: minutes - 1,
            seconds: 59,
          }));
        }
      }
    }, 1000);
    this.timer = setTimeout(() => {
      this.props.history.push("/dashboard_s");
      clearTimeout(this.timer);
    }, 5000);

    const userId = this.props.userDetail?.user_detail?.id; 
          recordEvent({
            eventName: "loan_application_completed",
            eventParams: { Platform: "web" ,value:"Amount sanctioned"},
            userId: userId
          });
      
  };

  render() {
    return (
      <div id="background" className="main_div">
         <div className="justify-content-evenly headAlign sticky-header align-items-baseline  shadowlinepure mb-20 "> 
            <Heading
            setModalState={this.setModelState}
            questionVisible={false}
              headingText={HEADING_ASSIGNINGNBFC}
              backprops={"/loandetail"}
              history={this.props.history}
            />
            </div>
        <div className="container">
          <div className="pb-4">
           
            <div className="wrapper-content e-sign">
              <div className="card-height px-4 pb-3 pt-1 w-100 text-center mx-auto ticketHistoryBorder">
                <div className="h-100 d-flex flex-column justify-content-between">
                  <img style={{marginTop:"40px", marginBottom:"40px"}} src="https://prod-static-docs.s3.ap-south-1.amazonaws.com/bansal_logo.png" alt="nbfc-logo" />
                  <p className="assigning_nfbfc_message">We are negotiating with <br/> multiple NBFCs to find you <br/> the best match!</p>
                  <div style={{height:"200px"}}>
                   
                    <p>
                      This may take upto 5 minutes
                      <br />
                      <span className="underline opacity-50">
                        {this.state.minutes < 10 ? `0${this.state.minutes}` : this.state.minutes}:
                        {this.state.seconds < 10
                          ? `0${this.state.seconds}`
                          : this.state.seconds}
                      </span>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
       
        </div>
            {this.state.modalState && <ModalBox statusDes={false} heading={payme_nbfc_heading} List={payme_nbfc_list} open={true} onChange={(props)=>{this.setModalState(props)}} imagesVisible={true}/> }
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    user: state.user,
    userDetail: state.userDetail,
  };
};

export default withRouter(connect(mapStateToProps, {})(AssigningNbfc));